module.exports = __webpack_public_path__ + "static/media/ios-tennisball.32a84626.svg";